// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadContent{
    position: relative;
    width: 100%;
    height: 88%;
    background-color: transparent !important;
    display: flex;
    justify-content: center;
    align-items: center;
}
.compactLoadItems{
    position: relative;
    width: 40%;
    height: 40%;
    background-color: transparent;
    display: block;
    justify-content: center;
    align-items: center;
}
.loadCont{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
}
.txtLoader{
    position: relative;
    font-size: larger;
    color: var(--txt-color);
    width: 100%;
    text-align: center;
   
}
.txtLoaderWhite{
  position: relative;
  font-size: larger;
  color: #003757;
  width: 100%;
  text-align: center;
 
}
/* @keyframes loader{
    0%{
        transform: scale(0);
        opacity: 1;
    }
    100%{
        transform: scale(1);
        opacity: 0;
    }
}
.loader::after,.loader::before{
    animation: loader 2s linear infinite;
    content: '';
    border: 4px solid #089aee;
    width: 48px;
    height: 48px;
    position: absolute;
    border-radius: 50%;
}
.loader::after{
    opacity: 0;
    animation-delay: 1s;
}
.loader{
    position: relative;
    left: -10%;
top: -30%;
}

.blink_me {
    display: inline-block;
    vertical-align: bottom;
    animation: blinker 1s linear infinite;
    animation-delay: -0.5s;
  }
  
  .blink_me span {
    float: left;
    overflow: hidden;
    animation: hideShow 5s linear infinite;
  }
  
  .blink_me span:nth-child(1) { animation-delay: -2s; }
  .blink_me span:nth-child(2) { animation-delay: -1s; }
  .blink_me span:nth-child(3) { animation-delay: -0s; }
  
  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }
  @keyframes hideShow {
    0%, 16.6%, 33.33%, 100% { width: 0; }
    16.66%, 33.3% { width: auto; }
  } */
  .loader {
    position: relative;
    width: 100px;
    height: 100px;
    background: transparent;
    border-radius: 50%;
    box-shadow: 10px 0px 50px rgba(252, 252, 252, 0.116);
    border: 1px dashed #4fb7f370;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  
  .loader::before {
    content: '';
    position: absolute;
    inset: 15px;
    background: transparent;
    border: 1px dashed#4fb7f370;
    border-radius: 50%;
    box-shadow: inset -5px -5px 25px rgba(0,0,0,0.25),
    inset 5px 5px 35px rgba(0,0,0,0.25);
  }
  
  .loader::after {
    content: '';
    position: absolute;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: 1px dashed#4fb7f370;
    box-shadow: inset -5px -5px 25px rgba(0,0,0,0.25),
    inset 5px 5px 35px rgba(0,0,0,0.25);
  }
  
  .loader span {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50%;
    height: 100%;
    background: transparent;
    transform-origin: top left;
    animation: radar81 2s linear infinite;
    border-top: 1px dashed #fff;
  }
  
  .loader span::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #00a2ff;
    transform-origin: top left;
    transform: rotate(-55deg);
    filter: blur(30px) drop-shadow(20px 20px 20px #20709f);
  }
  /**/
  .loaderWhite {
    position: relative;
  width: 100px;
  height: 100px;
  background: #2d7acc2e;
  border-radius: 50%;
  box-shadow: 10px 0px 50px rgba(253, 253, 253, 0.12);
  border: 1px dashed #06334d70;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  }
  
  .loaderWhite::before {
    content: '';
  position: absolute;
  inset: 15px;
  background: transparent;
  border: 1px dashed #061a2670;
  border-radius: 50%;
  box-shadow: inset -5px -5px 25px rgba(16, 51, 119, 0.25), inset 5px 5px 35px rgba(0, 39, 132, 0.25);
}
  
  .loaderWhite::after {
    content: '';
  position: absolute;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  border: 1px dashed #4fb7f370;
  box-shadow: inset -5px -5px 25px rgba(0,0,0,0.25), inset 5px 5px 35px rgba(43, 68, 130, 0.39);

  }
  .loaderWhite span {
    position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 100%;
  background: transparent;
  transform-origin: top left;
  animation: radar81 2s linear infinite;
  border-top: 1px dashed #0c1151;
  }
  
  .loaderWhite span::before {
    content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0053bd;
  transform-origin: top left;
  transform: rotate(-55deg);
  filter: blur(30px) drop-shadow(20px 20px 20px #20709f);

  }
  @keyframes radar81 {
    0% {
      transform: rotate(0deg);
    }
  
    100% {
      transform: rotate(360deg);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/styles/LoadData.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,cAAc;IACd,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;;AAEtB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,kBAAkB;;AAEpB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KAsDK;EACH;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,oDAAoD;IACpD,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,uBAAuB;IACvB,2BAA2B;IAC3B,kBAAkB;IAClB;uCACmC;EACrC;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B;uCACmC;EACrC;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,0BAA0B;IAC1B,qCAAqC;IACrC,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAyB;IACzB,sDAAsD;EACxD;EACA,GAAG;EACH;IACE,kBAAkB;EACpB,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,mDAAmD;EACnD,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB;;EAEA;IACE,WAAW;EACb,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;EAClB,mGAAmG;AACrG;;EAEE;IACE,WAAW;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,6FAA6F;;EAE7F;EACA;IACE,kBAAkB;EACpB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,8BAA8B;EAC9B;;EAEA;IACE,WAAW;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,sDAAsD;;EAEtD;EACA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;EACF","sourcesContent":[".LoadContent{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 88%;\r\n    background-color: transparent !important;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.compactLoadItems{\r\n    position: relative;\r\n    width: 40%;\r\n    height: 40%;\r\n    background-color: transparent;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.loadCont{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 50%;\r\n}\r\n.txtLoader{\r\n    position: relative;\r\n    font-size: larger;\r\n    color: var(--txt-color);\r\n    width: 100%;\r\n    text-align: center;\r\n   \r\n}\r\n.txtLoaderWhite{\r\n  position: relative;\r\n  font-size: larger;\r\n  color: #003757;\r\n  width: 100%;\r\n  text-align: center;\r\n \r\n}\r\n/* @keyframes loader{\r\n    0%{\r\n        transform: scale(0);\r\n        opacity: 1;\r\n    }\r\n    100%{\r\n        transform: scale(1);\r\n        opacity: 0;\r\n    }\r\n}\r\n.loader::after,.loader::before{\r\n    animation: loader 2s linear infinite;\r\n    content: '';\r\n    border: 4px solid #089aee;\r\n    width: 48px;\r\n    height: 48px;\r\n    position: absolute;\r\n    border-radius: 50%;\r\n}\r\n.loader::after{\r\n    opacity: 0;\r\n    animation-delay: 1s;\r\n}\r\n.loader{\r\n    position: relative;\r\n    left: -10%;\r\ntop: -30%;\r\n}\r\n\r\n.blink_me {\r\n    display: inline-block;\r\n    vertical-align: bottom;\r\n    animation: blinker 1s linear infinite;\r\n    animation-delay: -0.5s;\r\n  }\r\n  \r\n  .blink_me span {\r\n    float: left;\r\n    overflow: hidden;\r\n    animation: hideShow 5s linear infinite;\r\n  }\r\n  \r\n  .blink_me span:nth-child(1) { animation-delay: -2s; }\r\n  .blink_me span:nth-child(2) { animation-delay: -1s; }\r\n  .blink_me span:nth-child(3) { animation-delay: -0s; }\r\n  \r\n  @keyframes blinker {\r\n    50% {\r\n      opacity: 0;\r\n    }\r\n  }\r\n  @keyframes hideShow {\r\n    0%, 16.6%, 33.33%, 100% { width: 0; }\r\n    16.66%, 33.3% { width: auto; }\r\n  } */\r\n  .loader {\r\n    position: relative;\r\n    width: 100px;\r\n    height: 100px;\r\n    background: transparent;\r\n    border-radius: 50%;\r\n    box-shadow: 10px 0px 50px rgba(252, 252, 252, 0.116);\r\n    border: 1px dashed #4fb7f370;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    overflow: hidden;\r\n  }\r\n  \r\n  .loader::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 15px;\r\n    background: transparent;\r\n    border: 1px dashed#4fb7f370;\r\n    border-radius: 50%;\r\n    box-shadow: inset -5px -5px 25px rgba(0,0,0,0.25),\r\n    inset 5px 5px 35px rgba(0,0,0,0.25);\r\n  }\r\n  \r\n  .loader::after {\r\n    content: '';\r\n    position: absolute;\r\n    width: 35px;\r\n    height: 35px;\r\n    border-radius: 50%;\r\n    border: 1px dashed#4fb7f370;\r\n    box-shadow: inset -5px -5px 25px rgba(0,0,0,0.25),\r\n    inset 5px 5px 35px rgba(0,0,0,0.25);\r\n  }\r\n  \r\n  .loader span {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 50%;\r\n    height: 100%;\r\n    background: transparent;\r\n    transform-origin: top left;\r\n    animation: radar81 2s linear infinite;\r\n    border-top: 1px dashed #fff;\r\n  }\r\n  \r\n  .loader span::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: #00a2ff;\r\n    transform-origin: top left;\r\n    transform: rotate(-55deg);\r\n    filter: blur(30px) drop-shadow(20px 20px 20px #20709f);\r\n  }\r\n  /**/\r\n  .loaderWhite {\r\n    position: relative;\r\n  width: 100px;\r\n  height: 100px;\r\n  background: #2d7acc2e;\r\n  border-radius: 50%;\r\n  box-shadow: 10px 0px 50px rgba(253, 253, 253, 0.12);\r\n  border: 1px dashed #06334d70;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  }\r\n  \r\n  .loaderWhite::before {\r\n    content: '';\r\n  position: absolute;\r\n  inset: 15px;\r\n  background: transparent;\r\n  border: 1px dashed #061a2670;\r\n  border-radius: 50%;\r\n  box-shadow: inset -5px -5px 25px rgba(16, 51, 119, 0.25), inset 5px 5px 35px rgba(0, 39, 132, 0.25);\r\n}\r\n  \r\n  .loaderWhite::after {\r\n    content: '';\r\n  position: absolute;\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 50%;\r\n  border: 1px dashed #4fb7f370;\r\n  box-shadow: inset -5px -5px 25px rgba(0,0,0,0.25), inset 5px 5px 35px rgba(43, 68, 130, 0.39);\r\n\r\n  }\r\n  .loaderWhite span {\r\n    position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 50%;\r\n  height: 100%;\r\n  background: transparent;\r\n  transform-origin: top left;\r\n  animation: radar81 2s linear infinite;\r\n  border-top: 1px dashed #0c1151;\r\n  }\r\n  \r\n  .loaderWhite span::before {\r\n    content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: #0053bd;\r\n  transform-origin: top left;\r\n  transform: rotate(-55deg);\r\n  filter: blur(30px) drop-shadow(20px 20px 20px #20709f);\r\n\r\n  }\r\n  @keyframes radar81 {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n  \r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
